/**
 * Converts application public asset paths to root-relative URLs.
 *
 * Public assets live under `/media`, so a relative `media/...` path would be
 * resolved below the current route (for example, `/ru/media/...`).
 */
export const toStaticAssetUrl = (assetUrl: string): string => {
  if (!assetUrl.startsWith("media/")) {
    return assetUrl;
  }

  return `/${assetUrl}`;
};
